<mat-card>
    <mat-card-content>
        <mat-card-title>Regulasi</mat-card-title>
        <mat-card-subtitle>
        </mat-card-subtitle>

        <div fxLayout="row wrap" style="margin-bottom: 20px;">
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100">
                <button *ngIf="tokenStorageService.isSuperadmin() || tokenStorageService.isAdminKepegawaian()"
                    mat-raised-button color="primary" (click)="openDialog()">
                    Tambah Regulasi
                </button>
            </div>
            <div class="spacer"></div>
            <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100">
                <input matInput placeholder="Cari..." [(ngModel)]="searchTerm" class="search-field input-outline" />
            </div>

            <div fxFlex.gt-lg="8" fxFlex.gt-md="8" fxFlex.gt-xs="100" fxFlex="100">
                <button mat-raised-button color="primary" (click)="search()">
                    Cari
                </button>
            </div>
        </div>
        <div fxLayout="row wrap">
            <table mat-table [dataSource]="dataSource" class="full-width">
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef>Judul</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">{{ element.title }}</td>
                </ng-container>

                <ng-container matColumnDef="category-id">
                    <th mat-header-cell *matHeaderCellDef>Kategori</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">{{ element.category.name }}</td>
                </ng-container>

                <ng-container matColumnDef="upload-date">
                    <th mat-header-cell *matHeaderCellDef>Tanggal Upload</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">{{ element.uploadDate }}</td>
                </ng-container>

                <ng-container matColumnDef="filename">
                    <th mat-header-cell *matHeaderCellDef>Nama File</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">{{ element.filename }}</td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Aksi</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button
                            (click)="preview('', downloadService.downloadUrl(2, element.realFile!))">
                            <mat-icon>remove_red_eye</mat-icon>
                        </button>
                        <button *ngIf="tokenStorageService.isSuperadmin() || tokenStorageService.isAdminKepegawaian()"
                            mat-icon-button (click)="openDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button *ngIf="tokenStorageService.isSuperadmin() || tokenStorageService.isAdminKepegawaian()"
                            mat-icon-button (click)="confirmDialog(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <div *ngIf="dataSource.length === 0" class="center-col">Tidak ada data</div>
        </div>
        <div fxLayout="row wrap">
            <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="reload($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>